export default __webpack_public_path__ + "static/media/banner01.5f55161c.png";